import { Component, Input, OnInit } from '@angular/core';
import { TermsAndConditions, TermsAndConditionsService } from '../../../root/services/terms-and-conditions.service';
import { SignUpStateService } from '../../services/sign-up-state.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'hfc-sign-up-terms-and-conditions',
  templateUrl: './sign-up-terms-and-conditions.component.html',
  styleUrls: ['./sign-up-terms-and-conditions.component.scss']
})
export class SignUpTermsAndConditionsComponent implements OnInit {
  @Input() isDeclined = false;
  @Input() mortgageId!: string;

  public termsAndConditions: TermsAndConditions;
  public isLoading = true;

  constructor(
    private readonly termsAndConditionsService: TermsAndConditionsService,
    private readonly signUpStateService: SignUpStateService
  ) {}

  ngOnInit(): void {
    this.termsAndConditionsService
      .getCurrentTermsAndConditions()
      .pipe(
        tap((terms: TermsAndConditions) => {
          this.termsAndConditions = terms;
          this.isLoading = false;
          this.signUpStateService.termsAndConditionsId$.next(terms?.id);
        }),
        catchError(() => {
          this.isLoading = false;
          // optionally show fallback/error
          return of(null);
        })
      )
      .subscribe();
  }
}
